module.exports = __webpack_public_path__ + "resource/img/image037.5821d031.png";